export default [{
  text: '字体颜色',
  name: 'color',
  type: 'colorPicker',
}, {
  text: '字体大小',
  name: 'fontSize',
},
];
